import React from 'react';
import { RetentionSearchContext } from './RetentionSearchContext';
import { useRetentionSearch } from './useRetentionSearch';

interface RetentionSearchProviderProps {
    children: React.ReactNode;
}

const RetentionSearchProvider = ({ children }: RetentionSearchProviderProps) => {
    const value = useRetentionSearch();
    return (
        <RetentionSearchContext.Provider value={value}>
            {children}
        </RetentionSearchContext.Provider>
    );
};

export default RetentionSearchProvider;
